/* eslint-disable import/no-anonymous-default-export */

const isLoadingDashboard = (state) => state.dashboard.isLoadingDashboard;
const dashboardData = (state) => state.dashboard.dashboardData;

export default {
  isLoadingDashboard,
  dashboardData,
};
